import React from "react"

const Component = ({ address }) => {
  return (
    <iframe
      src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d406.5084468109806!2d139.53688507339487!3d35.40357554064628!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60185a859ed054e9%3A0x2641ac84a5f4e7!2z44CSMjQ0LTAwMDIg56We5aWI5bed55yM5qiq5rWc5biC5oi45aGa5Yy655-i6YOo55S677yR77yZIOS4reWtpuWPl-mok-Whvu-8oe-9g--9lA!5e0!3m2!1sja!2sjp!4v1737423947195!5m2!1sja!2sjp`}
      width="100%"
      height="300"
      frameborder="0"
      style={{ border: 0, marginBottom: "-0.5rem" }}
      allowfullscreen
      loading="lazy"
      title={`Google Map: ${address}`}
    />
  )
}

export default Component
